import api from '../../api'
import {
  GET_MEASURE_LIST_SUCCESS,
  GET_MEASURE_LIST_FAILURE,
  GET_MEASURE_FAILURE,
  GET_MEASURE_SUCCESS,
  UPDATE_MEASURE_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {
  getMeasureList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getMeasureList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
        commit(GET_MEASURE_LIST_FAILURE)
        return reject(response.body.$error)

      }
      commit(GET_MEASURE_LIST_SUCCESS, {
        measureList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_MEASURE_LIST_FAILURE)
      return reject(response.body.$error)
    })
  })

  },
 
  cleanMeasureList({commit}) {
    return commit(GET_MEASURE_LIST_FAILURE)
  },
  getMeasure({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getMeasure(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_MEASURE_FAILURE);
            reject();
          }
          commit(GET_MEASURE_SUCCESS, {
            measure: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_MEASURE_FAILURE);
          reject();
        })
    })
  },
 
  
  updateMeasure({commit}, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      let avaliables = [
        "id",
        "name",
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateMeasure(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },


  createMeasure({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.createMeasure(data)
      .then(response => {
        if (!response.ok) {
          api.stopLoader()
          return reject(response.body.$error);
        } else {
          api.stopLoader()
          return resolve(response.body.$success);
        }
      }, response => {
        api.stopLoader()
        return reject(response.body.$error);
      })
    })
  },
  
  
 
  deleteMeasure({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteMeasure(data)
         .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
    })
  },

  
  
};

const mutations = {

  [UPDATE_MEASURE_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.measure));
  },
  [GET_MEASURE_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_MEASURE_LIST_SUCCESS](state, action) {
    state.list = action.measureList;
    state.listUpdated = new Date();
  },
  [GET_MEASURE_FAILURE](state) {
    state.selected = null
  },
  [GET_MEASURE_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.measure));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/measure.js